import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import '@fontsource-variable/bricolage-grotesque/wght.css'
import '@fontsource-variable/public-sans/wght.css'
import '@fontsource-variable/jetbrains-mono/wght.css'
import './styles.css'
import { App } from './App'

const container = document.getElementById('root')!
const tree = (
  <StrictMode>
    <App />
  </StrictMode>
)

// The production build ships the homepage prerendered (scripts/prerender.mjs), so hydrate it.
// In dev the container is empty, so render from scratch.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree)
} else {
  createRoot(container).render(tree)
}
